import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource, MatPaginator } from '@angular/material';
import { CaseService } from '../../../shared/services/case.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { FormControl, FormGroup } from '@angular/forms';
import { EguardConfirmatialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { UserService } from '../../../shared/services/user.service';
import { environment } from '../../../../../environments/environment';
import { falseIfMissing } from 'protractor/built/util';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifyPopupComponent } from '../notify-popup/notify-popup.component';
import { LocalUserService } from '../../../shared/services/localUser';
import { PreSignService } from '../../../shared/services/preSign.service';
import { EguardCustomLoaderService } from '../../../../core/components/custom-loader/custom-loader.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ConfirmationDialogComponent } from 'app/main/shared/dialog/confirmation-dialog/confirmation-dialog.component';
import { HeaderTitleService } from 'app/services/header-title.service';

@Component({
  selector: 'pdfView',
  templateUrl: './pdfView.component.html',
  styleUrls: ['./pdfView.component.css'],
  providers: [
    PreSignService
  ]
})
export class PdfViewComponent implements OnInit {

  form: string;
  caseId: string;
  formId: string;
  commentId: string;
  token: string;
  org: string;

  dialogRef: any;

  petitonData: any;

  inventoryFees: any;

  pdfDifferences = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  showDetailedDifferences = false;

  firstPdf = false;
  firstUrl = null;

  isLoadingApprove = false;
  isLoadingDeny = false;
  isLoadingDiff = false;
  disableButton = false;
  displayedColumns: string[] = ['label', 'pdfValue', 'dbValue'];

  onlyOnePdf = false;
  inventoryPdf = false;
  


  constructor(
    public dialog: MatDialog,
    private caseService: CaseService,
    private router: Router,
    private cognito: CognitoUtil,
    private userService: UserService,
    private route: ActivatedRoute,
    private loaderService: EguardCustomLoaderService,
    private localuser: LocalUserService,
    private preSign: PreSignService,
    private sanitizer: DomSanitizer,
    private headerService: HeaderTitleService
  ) {

    this.form = this.route.snapshot.params['form'];
    this.caseId = this.route.snapshot.params['caseId'];
    this.formId = this.route.snapshot.params['formId'];

    this.commentId = this.formId == null ? this.caseId : this.formId;

    this.form = this.getPdfName(this.form);
  }

  getPdfName(name) {
    switch (name) {
      case '2.3':
        return '2.3';
      case '2.4':
        return '2.4';
      case '3.3':
        this.onlyOnePdf = true;
        this.inventoryPdf = true;
        this.disableButton = true;
        return 'PC3.3-Inventory_signed';
      default:
        if (this.formId) {
          this.onlyOnePdf = true;
          return name + '_signed';
        }
        return name;
    }
  }

  ngOnInit() {
    this.org = this.localuser.getOrganizationId();
    this.getPdfs();
    this.getCaseData();
    setTimeout(() => { this.sendHeaders(); });
    this.pdfDifferences.paginator = this.paginator;
  }
  sendHeaders(): void {
    this.headerService.sendHeader('picture_as_pdf', 'Review')
  }


  ngAfterViewInit() {
    
  }

  getDetailedPDfDifferences() {
    this.showDetailedDifferences = !this.showDetailedDifferences;
  }

  getDiffResults() {
    this.isLoadingDiff = true
    this.caseService.getSystemGeneratedAndUserUploadedCasePdfDifferences(this.org, this.caseId, this.form)
      .subscribe((response) => {
        if (response.results) {
          this.pdfDifferences.data = response.results;
          this.isLoadingDiff = false
        }
      });
  }

  getPdfs() {

    let storedFiles;

    this.preSign.getList(this.org, this.caseId, true)
      .subscribe(result => {

        storedFiles = result;
        let first, signed;
        if (!this.onlyOnePdf) {
          first = this.getPdfFromList(this.form + '.pdf', storedFiles);
          signed = this.getPdfFromList(this.form + '_signed.pdf', storedFiles);
          $('#first').attr('src', first.url);
          $('#signed').attr('src', signed.url);
        } else {
          first = this.getPdfFromList(this.form + '.pdf', storedFiles);
          $('#first').attr('src', first.url);
        }

      });
  }

  getPdfFromList(pdf, list) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].file_name === pdf && list[i].disposition == 'inline') {
        return list[i];
      }
    }
  }

  getCaseData() {
    this.caseService.getCaseById(this.org, this.caseId)
      .subscribe(result => {

        switch (this.form) {

          case '7.1':
          case '2.8':

            // for (let i = 0; i < result.due_forms.length; i++) {
            //   if (result.due_forms[i].details.id === this.form && result.due_forms[i].status === 'UPLOAD_FILED_FOR_CLERK') {
            //     this.petitonData = result.due_forms[i].petitonData;
            //   }
            // }
            // this.getDiffResults();
            break;
          case 'PC3.3-Inventory_signed':
            this.petitonData = result.petitionData;
            break;
          case 'PC2.8-annual-status-report_signed':
            break;
          default:
            this.petitonData = result.petitionData;
            this.getDiffResults();
            break;
        }



      });
  }

  approvePDF(final: boolean) {

    if (final) {
      this.isLoadingApprove = true;
      if (this.formId) {
        this.caseService.putStatusUpdate(this.caseId, this.formId, 'ACCEPT')
          .subscribe(result => {
            this.isLoadingApprove = false;
            this.router.navigate(['dashboard']);
          });
      } else {
        switch (this.form) {

          case '2.3':
            let data = {
              status: 'SET_HEARING'
            };

            this.putCase(data);
            break;

          case '3.4':
            data = {
              status: 'APPROVED_BY_JUDGE'
            };

            this.putCase(data);
            break;

          case 'PC3.3-Inventory_signed':
            let inventoryData = {
              status: 'INVENTORY_AMOUNT_SUBMITTED',
              inventoryAmount: this.inventoryFees.toString()
            };

            this.putCase(inventoryData);
            break;
        }
      }
    }
    else {
      this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        panelClass: "confirmDetails"

      });
      this.dialogRef.componentInstance.msg = 'You are about to confirm the information on this pdf.';
      this.dialogRef.afterClosed()
        .subscribe(response => {
          if (response == true) {
            this.isLoadingApprove = true;
            this.approvePDF(true);
          }
        });
    }
  }

  declinePDF(final: boolean) {

    let data: any;

    if (final) {
      this.isLoadingDeny = true;

      if (this.formId) {
        this.caseService.putStatusUpdate(this.caseId, this.formId, 'REJECT')
          .subscribe(result => {
            this.isLoadingApprove = false;
            this.router.navigate(['dashboard']);
          });
      } else {
        switch (this.form) {
          case '2.3':
            data = {
              status: 'UPLOAD_DENIED_BY_CLERK'
            };

            this.putCase(data);
            break;

          case '3.4':

            data = {
              status: 'UPLOAD_DENIED_BY_CLERK'
            };

            this.putCase(data);
            break;
        }
      }
    }
    else {
      this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        panelClass: "confirmDetails"

      });
      this.dialogRef.componentInstance.msg = 'You are about to deny this pdf.';
      this.dialogRef.afterClosed()
        .subscribe(response => {
          if (response == true) {
            this.isLoadingDeny = true;
            this.declinePDF(true);
          }
        });
    }
  }

  putCase(data) {
    this.caseService.putCaseNew(this.org, this.caseId, data)
      .subscribe(result => {
        this.router.navigate(['dashboard']);
      });
  }

  putCaseNew(data) {
    this.caseService.putCaseNew(this.org, this.caseId, data)
      .subscribe(result => {
        this.router.navigate(['dashboard']);
      });
  }

  putTwoEight(data) {
    this.caseService.putTwoEight(this.caseId, this.formId, data.status, data)
      .subscribe(result => {
        this.router.navigate(['dashboard']);
      });
  }

  putDueForm(data) {
    this.caseService.putDueForm(this.caseId, this.formId, 'APPROVED_BY_CLERK', data)
      .subscribe(result => {
        this.router.navigate(['dashboard']);
      });
  }

  checkModel(inventoryFees) {
    if (inventoryFees) {
      this.disableButton = false;
    } else {
      this.disableButton = true;
    }
  }

  cognitoCallback(message: string, result: any) {
    switch (message) {

      case 'FILEERROR':
        if (result.attempt !== environment.s3attempts) {
          this.cognito.s3get(this.org, this.caseId, result.file, this, result.trigger, result.attempt);
        }
        break;

      case 'FILE one':
        $('#first').attr('src', URL.createObjectURL(new Blob([new Uint8Array(result.data.Body)], { type: 'application/pdf' })));
        break;

      case 'FILE two':
        $('#signed').attr('src', URL.createObjectURL(new Blob([new Uint8Array(result.data.Body)], { type: 'application/pdf' })));
        break;

      default:
        break;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/common/pdfView/pdfView.component.ts